import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Input } from "../../Input";
import { Select } from "../../Select";
import { fromCountries } from "../../../../data/countries";
// import { Combobox } from "../../Combobox";
import { addressSaveSchema } from "../../validations/address";
import {
  useGetSubdivisions,
  useSaveUserAddress,
  useUpdateUserAddress,
} from "../../../../api/hooks/index";
import { ButtonGroup } from "../../../Buttons/ButtonGroup";
import {
  getStatesInputLabel,
  getZipCodeInputLabel,
  mapSubdivisionsToSelectOptions,
} from "../../../../helpers";
import { LoadingLayout } from "../../../Layouts/LoadingLayout";
// import { useEffect, useState } from "react";
// import { AddressAutocomplete } from "../../AddressAutocomplete";
// import { validateFullAddress } from "../../../../utils/validateAddress";

export function SaveAddressForm({ setOpen, selectedAddress }) {
  // const [showAddressDetails, setShowAddressDetails] = useState(false);
  // const [suggestedAddress, setSuggestedAddress] = useState(null);
  // const [enteredAddress, setEnteredAddress] = useState(null);
  // const [showSuggestedPanel, setShowSuggestedPanel] = useState(false);
  // const [skipAddressValidation, setSkipAddressValidation] = useState(false);

  const { handleSubmit, control, watch } = useForm({
    defaultValues: selectedAddress
      ? { ...selectedAddress }
      : {
          name: "",
          address1: "",
          address2: "",
          city: "",
          state: { id: "", name: "" },
          zip: "",
          country: fromCountries[0],
          phone: "",
          email: "",
        },
    resolver: yupResolver(addressSaveSchema),
  });

  const watchCountry = watch("country");
  const countryId = watchCountry?.id;

  const { isLoading: isSaveLoading, mutateAsync: saveAddress } =
    useSaveUserAddress();
  const { isLoading: isUpdateLoading, mutateAsync: updateAddress } =
    useUpdateUserAddress();
  const { data: provinces, isLoading: isProvincesLoading } =
    useGetSubdivisions("CA");

  const provinceOptions = mapSubdivisionsToSelectOptions(provinces);
  const isLoading = isSaveLoading || isUpdateLoading;

  // const handleAddressBlur = () => {
  //   if (watch("address1")) setShowAddressDetails(true);
  // };

  // const handleAddressSelect = (addressObj) => {
  //   setValue("address1", addressObj.address);
  //   setValue("city", addressObj.city);
  //   setValue("zip", addressObj.zip);
  //   setValue("country", addressObj.country); // {id, name}
  //   setValue("state", addressObj.state); // {id, name}
  //   setShowAddressDetails(true);
  // };

  // const validateAddressBeforeSave = async (data) => {
  //   const addressToValidate = {
  //     address1: data.address1,
  //     city: data.city,
  //     state: data.state,
  //     country: data.country,
  //     zip: data.zip,
  //   };

  //   try {
  //     const result = await validateFullAddress(addressToValidate);

  //     if (result) {
  //       const { entered, suggested } = result;

  //       const isDifferent =
  //         suggested.address1 !== entered.address1 ||
  //         suggested.city !== entered.city ||
  //         suggested.state?.id !== entered.state?.id ||
  //         suggested.country?.id !== entered.country?.id ||
  //         suggested.zip !== entered.zip;

  //       if (isDifferent) {
  //         setSuggestedAddress(suggested);
  //         setEnteredAddress({
  //           ...entered,
  //           name: data.name,
  //           phone: data.phone,
  //           email: data.email,
  //         });
  //         setShowSuggestedPanel(true);
  //         return false;
  //       }
  //     }
  //   } catch (err) {}

  //   return true;
  // };

  const buildAddressPayload = (data) => ({
    name: data.name,
    address1: data.address1,
    address2: data.address2,
    city: data.city,
    state: {
      id: data.state.id,
      name: data.state.name,
    },
    zip: data.zip,
    country: {
      id: data.country.id,
      name: data.country.name,
    },
    phone: data.phone,
    email: data.email,
  });

  const handleFormSubmit = async (data) => {
    const address = buildAddressPayload(data);

    try {
      if (selectedAddress) {
        await updateAddress({
          addressId: selectedAddress.addressId,
          address,
        });
      } else {
        await saveAddress(address);
      }

      setOpen(false);
    } catch (err) {
      console.error("Failed to submit address:", err);
    }
  };

  // const submitAddress = async (data) => {
  //   if (selectedAddress) {
  //     await updateAddress({
  //       addressId: data.addressId,
  //       address: data,
  //     });
  //   } else {
  //     await saveAddress(data);
  //   }
  //   setOpen(false);
  // };

  // const handleFormSubmit = async (data) => {
  //   const address = {
  //     name: data.name,
  //     address1: data.address1,
  //     address2: data.address2,
  //     city: data.city,
  //     state: {
  //       id: data.state.id,
  //       name: data.state.name,
  //     },
  //     zip: data.zip,
  //     country: {
  //       id: data.country.id,
  //       name: data.country.name,
  //     },
  //     phone: data.phone,
  //     email: data.email,
  //   };

  //   try {
  //     await saveAddress(address);
  //     setOpen(false);
  //   } catch (err) {}
  // };

  // const useSuggestedAddress = () => {
  //   if (!suggestedAddress) return;

  //   setValue("address1", suggestedAddress.address1);
  //   setValue("city", suggestedAddress.city);
  //   setValue("state", suggestedAddress.state);
  //   setValue("country", suggestedAddress.country);
  //   setValue("zip", suggestedAddress.zip);

  //   // Preserve user-entered name, phone, email
  //   setValue("name", enteredAddress.name);
  //   setValue("phone", enteredAddress.phone);
  //   setValue("email", enteredAddress.email);

  //   setShowSuggestedPanel(false);
  // };

  // const keepEnteredAddress = () => {
  //   setShowSuggestedPanel(false);
  //   setSkipAddressValidation(true); // prevent validation on save
  // };

  // useEffect(() => {
  //   if (selectedAddress) {
  //     setShowAddressDetails(true);
  //   }
  // }, [selectedAddress]);

  if (isProvincesLoading) return <LoadingLayout />;

  return (
    <>
      <div className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
        <div className="sm:col-span-6">
          <Input label="Full Name" name="name" control={control} />
        </div>
        <div className="sm:col-span-4">
          {/* <AddressAutocomplete
            label="Address"
            name="address1"
            control={control}
            onSelect={handleAddressSelect}
            setValue={setValue}
            onBlur={handleAddressBlur}
          /> */}
          <Input name="address1" label="Address" control={control} />
        </div>
        <div className="sm:col-span-2">
          <Input label="Apt / Unit / Suite" name="address2" control={control} />
        </div>

        <>
          <div className="sm:col-span-3">
            <Input label="City" name="city" control={control} />
          </div>
          <div className="sm:col-span-3">
            <Select
              label={getStatesInputLabel(countryId)}
              name="state"
              control={control}
              options={provinceOptions}
            />
          </div>
          <div className="sm:col-span-3">
            <Input
              label={getZipCodeInputLabel(countryId)}
              name="zip"
              control={control}
            />
          </div>
          <div className="sm:col-span-3">
            <Select
              label="Country"
              name="country"
              control={control}
              options={fromCountries}
              disabled
            />
          </div>
        </>

        <div className="sm:col-span-3">
          <Input label="Phone" name="phone" control={control} />
        </div>
        <div className="sm:col-span-3">
          <Input label="Email" name="email" control={control} />
        </div>
      </div>
      {/* 
      {showSuggestedPanel && suggestedAddress && (
        <div className="mt-4 p-3 border rounded bg-gray-50">
          <h4 className="font-medium mb-2">Suggested Address</h4>
          <p>
            {suggestedAddress.address1}, {suggestedAddress.city},{" "}
            {suggestedAddress.state.name}, {suggestedAddress.country.name},{" "}
            {suggestedAddress.zip}
          </p>
          <div className="mt-2 flex gap-2 flex justify-end">
            <ButtonGroup
              primaryButtonText="Use Suggested"
              primaryButtonOnClick={useSuggestedAddress}
              secondaryButtonText=" Keep My Address"
              secondaryButtonOnClick={keepEnteredAddress}
              isLoading={isLoading}
            />
          </div>
        </div>
      )} */}

      <div className="mt-5 sm:mt-5">
        <ButtonGroup
          primaryButtonText="Save"
          primaryButtonOnClick={handleSubmit(handleFormSubmit)}
          secondaryButtonText="Cancel"
          secondaryButtonOnClick={() => setOpen(false)}
          isLoading={isLoading}
        />
      </div>
    </>
  );
}
